export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            STARTED: 'STARTED',
            IN_PROGRESS: 'IN_PROGRESS',
            FINISHED: 'FINISHED'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('forms.Not started'),
            STARTED: $translate.instant('forms.Started'),
            IN_PROGRESS: $translate.instant('forms.In progress'),
            FINISHED: $translate.instant('forms.Finished')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/submission/status/index.js